export class EConsultantComponentService {
    constructor() {
        "ngInject";
        this.companyConsultationState = {};
    }
}
